import React from 'react'
import { ImageManager } from 'Core/imageManager'
import { Wrapper } from 'SRC/ui/FormElements'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { LogoCropper } from 'SRC/modules/users/Registration/components/Form/Content/LogoCropper'
import { getTempLogo } from 'SRC/modules/users/Registration/selectors'
import { setTempLogo } from 'SRC/modules/users/Registration/actions'
import { getUserInfo, getNewLogo } from '../../../../../selectors'
import { setNewLogo } from '../../../../../actions'
import { imagesCDN } from 'Core/constants'
import { Preloader } from 'SRC/ui/Preloader'

export class Image extends React.Component {
  constructor (props) {
    super(props)

    this.imageManager = new ImageManager()
    this.state = {isLoading: true}
    this.isComponentMounted = true
  }

  async componentDidMount () {
    if (this.props.existingLogo) {
      const arStrings = this.props.existingLogo.split('/')
      const name = arStrings[arStrings.length - 1]
      this.imageManager.loadImageFromUrl(`${imagesCDN}${this.props.existingLogo}`).then(image => {
        if (this.isComponentMounted) {
          this.props.setNewLogo({file: image.file, name, isOriginal: true})
          this.setState({...this.state, isLoading: false})
        }
      }).catch(() => {
        if (this.isComponentMounted) {
          this.props.setNewLogo({file: '', name})
          this.setState({...this.state, isLoading: false})
        }
      })
    } else {
      this.setState({...this.state, isLoading: false})
    }
  }

  componentWillUnmount () {
    this.isComponentMounted = false
  }

  onChange = e => {
    const { setTempLogo } = this.props

    if (!this.props.isFormBlocked) {
      const image = e.target.files[0]

      console.log('image', image)

      const reader = new FileReader()
      reader.addEventListener('load', () => {
        setTempLogo({ file: reader.result, imageName: `${image.name}_${Math.round(Math.random() * 10000)}` })

        if (this.fileInput && this.fileInput) {
          this.fileInput.value = null
        }
      })
      reader.readAsDataURL(e.target.files[0])
    }
  }

  removeImage = () => {
    if (!this.props.isFormBlocked) {
      this.props.setNewLogo(null)
    }
  }

  render () {
    const { tempLogo } = this.props

    return <React.Fragment>
      <input
        id='logo'
        name='logo'
        type='file'
        accept={this.imageManager.allowedTypes.join(',')}
        style={{display: 'none'}}
        onChange={this.onChange}
        key='input'
        disabled={this.props.isFormBlocked}
      />

      {!this.props.newLogo && !this.props.existingLogo
        ? <Wrapper isFullWidth key='addLogoBtn'>
          <label className='dodaj-logo' htmlFor='logo' key='label' style={{textAlign: 'center'}}>
            <i className='ico-tab-fotografije ico' />
            Dodaj logo
          </label>
        </Wrapper>
        : (
          <div className='dodaj-logo-group' style={{marginBottom: '15px'}} key='editLogo'>
            {this.state.isLoading
              ? <Preloader />
              : <div className='logo-img' key='logo'>
                {this.props.newLogo && this.props.newLogo.file ? <img src={this.props.newLogo.file} /> : null}
              </div>
            }
            <div className='logo-btns' key='buttons'>
              <label htmlFor='logo'><i className='ico ico-poslate-poruke' />Dodaj</label>
              <a
                onClick={this.removeImage}
                style={this.props.newLogo && this.props.newLogo.file ? null : {display: 'none'}}
              >
                <i className='ico ico-obrisati' />Obriši
              </a>
            </div>
          </div>
        )
      }

      {tempLogo
        ? (
          <div className='logo-cropper'><LogoCropper isUpdateProfile /></div>
        )
        : null
      }
    </React.Fragment>
  }
}

Image.propTypes = {
  newLogo: PropTypes.shape({
    file: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOriginal: PropTypes.bool
  }),
  tempLogo: PropTypes.any.isRequired,
  setNewLogo: PropTypes.func.isRequired,
  setTempLogo: PropTypes.func.isRequired,
  isFormBlocked: PropTypes.bool.isRequired,
  existingLogo: PropTypes.string
}

Image.defaultProps = {
  isFormBlocked: false
}

const mapStateToProps = state => {
  const props = {newLogo: getNewLogo(state)}
  const userInfo = getUserInfo(state)
  if (userInfo.media && Array.isArray(userInfo.media)) {
    const logo = userInfo.media.filter(item => item.title === 'profile-picture')
    if (logo.length) {
      props.existingLogo = logo[0].fd
    }
  }

  const tempLogo = getTempLogo(state)

  props.tempLogo = tempLogo

  return props
}

export default connect(mapStateToProps, { setNewLogo, setTempLogo })(Image)
